import * as React from 'react';
import classNames from 'classnames';

import styles from './employerAssociationStyles.scss';

import { Maybe } from 'interfaces/graphql-typings';

interface EmployerProps {
  aumRange?: Maybe<string>;
  fundType?: Maybe<string>;
  profileCity?: Maybe<string>;
  employerStyles?: string;
  cityStyles?: string;
}

const AnonEmployerAssociation: React.FC<EmployerProps> = ({
  aumRange,
  fundType,
  profileCity,
  employerStyles,
  cityStyles
}): React.ReactElement => {
  const hideEmployerInfo = fundType === 'Other' || fundType === 'Investment Bank' || !fundType;

  return (
    <div>
      {!hideEmployerInfo && (
        <div className={classNames(styles.anonEmployer, employerStyles)}>
          {aumRange === 'N/A' ? '' : aumRange} {fundType}
        </div>
      )}
      <div className={classNames(styles.anonCity, cityStyles)}>{profileCity}</div>
    </div>
  );
};

export default AnonEmployerAssociation;
